var _defs, _rect, _rect2, _path, _polygon, _polygon2, _rect3, _path2, _path3, _path4, _polygon3, _path5, _path6, _polygon4, _polygon5, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebProcess02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 432 432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#241c12;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 257.66,
    y: 38.45,
    width: 16.46,
    height: 303.58
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 270.98,
    y: 83.34,
    width: 18.81,
    height: 236.43
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M327.73,375.41h-20v-152.54c0-19.24-17.75-33.61-33.61-33.61v-20c28.56,0,53.61,25.05,53.61,53.61v152.54Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "312.51 100.36 366.58 87.82 339.55 112.89 312.51 100.36"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "299.02 162.84 352.52 173.21 326.44 157.8 299.02 162.84"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 178.49,
    y: 93.63,
    width: 69.72,
    height: 46.47,
    transform: "translate(78.11 -85.34) rotate(27.51)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M241.05,105.24h41.55v69.72h-41.55c-4.25,0-7.71-3.45-7.71-7.71v-54.3c0-4.25,3.45-7.71,7.71-7.71Z",
    transform: "translate(93.89 -103.32) rotate(27.51)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.49,84.92l69.12,19.35,12.56-24.12-25.08-13.06c-20.55-10.7-45.89-2.72-56.6,17.83h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.56,296.19l-33.68-17.54,30.81-59.16,21.95-35.06c3.7-5.9,7.16-11.95,10.37-18.13l28.51-54.74,30.04,15.64-49.1,90.04c-1.66,3.05-3.1,6.21-4.3,9.47l-3.8,10.32-30.81,59.16Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "320.71 135.92 364.33 122.56 381.05 139.28 407.69 148.94 334.55 144.76 320.71 135.92"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.6,372.01h173.98v14.11h-185.98v-2.11c0-6.62,5.38-12,12-12Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.6,110.35l13.71-1.18s-13.71,9.6-13.71,9.99,24.91,13.52,24.91,13.52h-36.86l30.17,22.33-26.38-2.81-21.47-25.21,29.63-16.65Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "38.47 386.12 189.45 370.84 189.45 353.01 38.47 368.29 38.47 386.12"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "157.78 369.5 166.66 386.06 177.63 386.06 177.63 364.05 157.78 369.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M180.05,357.52l-21.16-1.18h0c0-2.55,2.15-4.58,4.69-4.44l12.26.68c2.36.13,4.2,2.08,4.2,4.44v.49Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.66,360.33l-21.16-1.18h0c0-2.55,2.15-4.58,4.69-4.44l12.26.68c2.36.13,4.2,2.08,4.2,4.44v.49Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.51,362.48l-21.16-1.18h0c0-2.55,2.15-4.58,4.69-4.44l12.26.68c2.36.13,4.2,2.08,4.2,4.44v.49Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.35,364.64l-21.16-1.18h0c0-2.55,2.15-4.58,4.69-4.44l12.26.68c2.36.13,4.2,2.08,4.2,4.44v.49Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.19,366.79l-21.16-1.18h0c0-2.55,2.15-4.58,4.69-4.44l12.26.68c2.36.13,4.2,2.08,4.2,4.44v.49Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.03,368.95l-21.16-1.18h0c0-2.55,2.15-4.58,4.69-4.44l12.26.68c2.36.13,4.2,2.08,4.2,4.44v.49Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.47,368.29s-25.53,11.75-26.51,17.83h26.51l3.85-12.54-3.85-5.29Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.02,71.04c1.24-2.52,2.73-4.85,4.28-7.12,1.56-2.27,3.21-4.46,4.94-6.59,1.73-2.13,3.54-4.19,5.44-6.18,1.91-1.98,3.89-3.91,6.1-5.64-1.24,2.52-2.73,4.85-4.27,7.13-1.56,2.27-3.21,4.46-4.94,6.58-1.73,2.13-3.54,4.19-5.44,6.18-1.92,1.98-3.89,3.91-6.1,5.64Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M331.85,73.67c5.24-2.93,10.59-5.59,15.98-8.15,2.69-1.31,5.41-2.52,8.12-3.77l8.19-3.62,8.25-3.47c2.77-1.1,5.53-2.26,8.32-3.31,5.57-2.16,11.18-4.22,16.91-6.01-5.23,2.93-10.59,5.6-15.98,8.16-2.69,1.31-5.42,2.51-8.12,3.77l-8.19,3.61-8.26,3.47c-2.77,1.11-5.53,2.26-8.32,3.31-5.57,2.16-11.18,4.22-16.91,6.01Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M367.85,111.01c14.16-1.88,28.56-1.71,42.67.55-14.16,1.89-28.56,1.69-42.67-.55h0Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M369.52,160.34c4.21.03,8.37.34,12.51.76,2.08.18,4.14.47,6.21.71l6.18.88c4.11.63,8.21,1.39,12.28,2.24,4.08.86,8.14,1.82,12.15,3.07-4.21-.02-8.37-.34-12.51-.76-4.14-.42-8.27-.94-12.38-1.59l-6.15-1.04c-2.04-.4-4.09-.75-6.13-1.21-4.08-.86-8.14-1.82-12.15-3.07Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M339.55,182.34c3.52.41,6.95,1.09,10.35,1.88,3.41.77,6.77,1.69,10.12,2.68,3.34,1,6.65,2.09,9.93,3.32,3.28,1.21,6.52,2.52,9.68,4.12-3.52-.4-6.95-1.09-10.36-1.88-3.41-.77-6.77-1.69-10.11-2.68-3.34-1.01-6.65-2.09-9.92-3.32-3.28-1.21-6.52-2.52-9.69-4.12Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M334.35,199.34c6.25,3.75,12.32,7.73,18.34,11.8,3.02,2.01,5.98,4.11,8.97,6.17l8.87,6.31,8.78,6.44c2.89,2.19,5.82,4.34,8.68,6.58,5.76,4.43,11.45,8.94,16.97,13.7-6.25-3.74-12.33-7.73-18.34-11.8-3.02-2.01-5.98-4.12-8.97-6.17l-8.87-6.31-8.78-6.44c-2.89-2.19-5.82-4.34-8.68-6.58-5.76-4.43-11.45-8.94-16.97-13.7Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337.18,225.67c3.33,3.14,6.43,6.46,9.45,9.85,1.53,1.68,2.98,3.42,4.47,5.13l4.34,5.24c2.86,3.52,5.61,7.13,8.29,10.79,2.68,3.67,5.27,7.4,7.63,11.32-3.33-3.14-6.44-6.46-9.46-9.85-3.02-3.39-5.96-6.84-8.8-10.38l-4.21-5.34c-1.36-1.81-2.76-3.6-4.08-5.45-2.68-3.67-5.27-7.4-7.64-11.32Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.35,110.67c-25.58.71-51.64,5.6-74.1,18.35-7.4,4.26-14.61,9.29-20.37,15.66,3.42-4.12,7.67-7.64,11.91-10.9,18.37-13.43,40.66-20.94,63.04-24.14,6.21-1.01,13.17-1.48,19.42-1.96,2.04-.11,2.2,2.94.1,3h0Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.3,127.39c-32.14-2.73-66.13,3.16-92.79,22.13-3.78,2.71-7.42,5.65-10.63,9.04,3.11-3.48,6.69-6.52,10.41-9.34,26.44-19.89,60.66-26.71,93.23-24.82,1.96.14,1.81,3.12-.21,2.99h0Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.02,145.04c-30.1-6.4-62.59.71-87.11,19.4-3.51,2.66-6.91,5.49-9.96,8.69,2.96-3.28,6.29-6.21,9.73-8.98,24.34-19.66,57.15-27.67,87.89-22.05,1.94.37,1.44,3.31-.55,2.95h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebProcess02);
export default __webpack_public_path__ + "static/media/WebProcess-02.3cf2a30d2518ddea28927e78f3ca2235.svg";
export { ForwardRef as ReactComponent };